import { render, staticRenderFns } from "./QuestionDeviceType.vue?vue&type=template&id=c40f358c&"
import script from "./QuestionDeviceType.vue?vue&type=script&lang=js&"
export * from "./QuestionDeviceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports